import { useLocation } from 'react-router-dom'

export const RECRUITER_ROLES_PATH = '/recruiter/roles'
export const INTERVIEWER_ROLES_PATH = '/interviewer/roles'

/** Role pages are shared by the recruiter and interviewer foci; links stay in the current one. */
export function rolesBasePath(pathname: string): string {
  return pathname.startsWith('/interviewer') ? INTERVIEWER_ROLES_PATH : RECRUITER_ROLES_PATH
}

export function useRolesBasePath(): string {
  return rolesBasePath(useLocation().pathname)
}
